module.exports = __webpack_public_path__ + "img/square_outlines.e6218a60.svg";